import { render, staticRenderFns } from "./targeting-description.vue?vue&type=template&id=1490d1d1&scoped=true"
import script from "./targeting-description.vue?vue&type=script&setup=true&lang=js"
export * from "./targeting-description.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490d1d1",
  null
  
)

export default component.exports